export const SKILLS = [
  {
    title: 'Data Science & Analytics',
    icon: '/skills/analytics.png',
    skills: [
      { skill: 'Python (Pandas, NumPy)', percentage: '90%' },
      { skill: 'Scikit-learn', percentage: '85%' },
      { skill: 'Matplotlib / Seaborn', percentage: '85%' },
      { skill: 'Statsmodels (A/B testing, regression)', percentage: '80%' },
      { skill: 'SQL', percentage: '90%' },
      { skill: 'Tableau / Power BI', percentage: '75%' }
    ],
  },
  {
    title: 'Data Engineering & APIs',
    icon: '/skills/backend.png',
    skills: [
      { skill: 'Flask / FastAPI', percentage: '85%' },
      { skill: 'ETL Pipelines (batch/stream)', percentage: '85%' },
      { skill: 'Airflow', percentage: '75%' },
      { skill: 'PySpark', percentage: '75%' },
      { skill: 'RESTful APIs', percentage: '85%' },
      { skill: 'LLM Integrations (HuggingFace)', percentage: '70%' }
    ],
  },
  {
    title: 'Databases & Warehousing',
    icon: '/skills/database.png',
    skills: [
      { skill: 'PostgreSQL', percentage: '85%' },
      { skill: 'MySQL', percentage: '80%' },
      { skill: 'MongoDB', percentage: '65%' },
      { skill: 'Redis (caching/queues)', percentage: '70%' },
      { skill: 'BigQuery / Snowflake / Redshift (familiar)', percentage: '55%' }
    ],
  },
  {
    title: 'Cloud & DevOps Tooling',
    icon: '/skills/tools.png',
    skills: [
      { skill: 'AWS (S3, Lambda, EC2, Glue)', percentage: '75%' },
      { skill: 'Docker', percentage: '70%' },
      { skill: 'Git & GitHub Actions', percentage: '85%' },
      { skill: 'CI/CD Pipelines', percentage: '80%' },
      { skill: 'ELK Stack (logs/metrics)', percentage: '70%' },
      { skill: 'Testing (unit/integration)', percentage: '75%' }
    ],
  },
  {
    title: 'Frontend (Supporting)',
    icon: '/skills/frontend.png',
    skills: [
      { skill: 'React.js', percentage: '80%' },
      { skill: 'TypeScript', percentage: '75%' },
      { skill: 'Redux', percentage: '70%' },
      { skill: 'UI Libraries (MUI/Sass)', percentage: '70%' }
    ],
  },
];
